export default {
    methods: {
        tokenOpenID() {
            const params = new URLSearchParams(window.location.search);
            let _code, _state, _sessionState;
            if (params.get('code') && params.get('state') && params.get('session_state')) {
                this.$store.commit('setMensajeApp', 'Validando Autenticacion de Ciudadania Digital ...')
                this.$store.commit('setLoadingApp', true)
                _code = params.get('code');
                _state = params.get('state');
                _sessionState = params.get('session_state');
               this.$http.get(`${this.$apiUrl}/openid/token`, {
                    params: {
                        code: _code,
                        state: _state,
                        session_state: _sessionState
                    }
                }).then((response) => {
                    this.$store.commit('setLoadingApp', false)
                    this.$Progress.finish();
                    const token = response.data.access_token;
                    const modulos = response.data.modulos;
                    this.$storage.set("code", token);
                    this.$store.commit('setToken', token)
                    this.$storage.set("modulos", modulos);
                    this.$store.commit('setModulos', modulos);
                    this.$storage.set("token", response.data.refresh_token);
                    this.$store.commit('setRefreshToken', response.data.refresh_token);
                    if (modulos.length === 1) {
                        var modulosHijos = modulos[0].modulosHijos
                        if (modulosHijos.length === 1) {
                            this.$router.push({ name: 'RedirectModule', params: { id: modulosHijos[0].id } })
                        } else {
                            this.$router.push('/inicio')
                        }
                    } else {
                        this.$router.push('/inicio')
                    }
                }).catch((error) => {
                    console.log('error en ciudadania digital al solicitar token');
                    this.$store.commit('setLoadingApp', false)
                    this.$router.push('/');
                    this.$store.commit('setError', 'No se pudo realizar la autenticación de Ciudadania Digital');
                });
            } else if (params.get('error') && params.get('error_description')) {
                this.$store.commit('setError', params.get('error_description'))
                this.$router.push('/');
                if(params.get('action')){
                    params.delete('action')
                    this.start_session_ciudadania()
                }
            }else if(params.get('action')){
                params.delete('action')
                this.start_session_ciudadania()
            }
        },

        loginOpenID(data) {
            this.loading_ciudadania=true;
            this.$http.get(`${this.$apiUrl}/openid/login`).then(response => {
                this.$Progress.finish();
                window.location.href = response.data.data.urlAutorizacion;
            }).catch((error) => {
                this.loading_ciudadania=false;
               console.log(' login ciudadania mjti incorrecto')
                this.$Progress.finish();
                if (error) {
                    this.$Progress.fail();
                    this.$store.commit('setError', 'El Servicio de Ciudadania Digital tiene problemas, Contactese con el administrador');
                }
            });
        }
    }
};
